import { useStaticQuery, graphql } from "gatsby";

export const useFooterData = () => {
  const data = useStaticQuery(
    graphql`
      query FooterData {
        menu: wpMenu(name: { eq: "Footer Menu" }) {
          menuItems {
            nodes {
              id
              label
              path
              target
              cssClasses
              parentId
            }
          }
        }
        legal: wpMenu(name: { eq: "Footer Legal" }) {
          menuItems {
            nodes {
              id
              label
              path
              target
              cssClasses
              parentId
            }
          }
        }
        social: wpMenu(name: { eq: "Footer Social" }) {
          menuItems {
            nodes {
              id
              label
              path
              target
              cssClasses
              parentId
            }
          }
        }
        cta: wpMenu(name: { eq: "Footer CTA" }) {
          menuItems {
            nodes {
              id
              label
              path
              target
              cssClasses
              parentId
            }
          }
        }
      }
    `
  )
  return data;
}